import React, {Component} from 'react';
import {Button} from "reactstrap";
import {Table} from "react-bootstrap";
import axios from "axios";
import {request} from "../../helper/APIUtils";
import ReactLoading from "react-loading";
import cacheInstance from "../../components/cache/Cache";
import {getDocumentStatusColumns} from "./helper/columns";

class GibDocumentList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            oldDateType: "",
            oldRefresh: undefined,
            documentStatusList:[],
            endpoint: '',
            loading: true,
        }
        this._fetchToken = undefined;
        this.fetchWaited = this.fetchWaited.bind(this);
        this.createBody = this.createBody.bind(this);

    }

    componentWillUnmount() {
        //cancel pending requests on page unload.
        if (typeof this._fetchToken !== typeof undefined) {
            this._fetchToken.cancel('unload')
        }
    }

    componentDidMount() {
        this.fetchWaited()
    }

    componentDidUpdate() {
        this.fetchWaited();
    }

    fetchWaited() {
        let self = this;
        if (self.isDisableFetchData())
            return;
        else
            self.setState(
                {
                    oldRefresh: self.props.refresh,
                    oldDateType: self.props.dateType
                })
        let type = "DocStatus-" + this.props.dateType + "-" + this.props.type;
        let url = self.setEndpoint();
        let documentStatusList = self.state.documentStatusList;
        if (typeof self._fetchToken !== typeof undefined) {
            self._fetchToken.cancel();
        }
        self._fetchToken = axios.CancelToken.source();

        let params = {
            url: url,
            method: "get",
            cancelToken: self._fetchToken.token
        };
        self.setState({loading: true});
        cacheInstance.get(type).then(responseObject =>{
            if(responseObject){
                setTimeout(()=>self.setState({loading: false}),0.7*1000);
                self.setDocumentStatusList(responseObject)
            }else{
                request(params)
                    .then(function (response) {
                        let data = response.data;
                        self.setDocumentStatusList(data);
                        cacheInstance.set(type, response.data);
                        self.setState({loading: false});
                    }).catch(function (error) {
                        self.setState({loading: false});
                    }
                )
            }
        })
    }

    isDisableFetchData() {
        let refresh = this.props.refresh;
        /* if ( this.state.oldRefresh === refresh)
             return true;*/
        return (this.state.oldDateType === this.props.dateType && this.state.oldRefresh === refresh);
    }


    setEndpoint() {
        let url = ''
        let type = this.props.type;
        let dateType = this.props.dateType;
        let endpoint = ''

        if (type === "invoice") {
            url = `/waitedGibOutbox/fetch?showOnDocuments=${this.props.showOnDocuments}&timeType=`;
            endpoint = '/waitedGibOutbox'
        } else if (type === "archiveInvoice") {
            url = `/eArchiveStatus/fetch?showOnDocuments=${this.props.showOnDocuments}&timeType=`;
            endpoint = '/eArchiveStatus';
        } else if (type === "despatch") {
            url = `/edespatchStatus/fetch?showOnDocuments=${this.props.showOnDocuments}&timeType=`;
            endpoint = '/edespatchStatus';
        } else if (type === "mm") {
            url = `/eArchiveVoucherStatus/fetch?showOnDocuments=${this.props.showOnDocuments}&timeType=`;
            endpoint = '/eArchiveVoucherStatus'
        } else if (type === "smm") {
            url = `/eSmmArchiveVoucherStatus/fetch?showOnDocuments=${this.props.showOnDocuments}&timeType=`;
            endpoint = '/eSmmArchiveVoucherStatus'
        } else if (type === "edefter-bildirim") {
            url = `/secondary-copy-transfer-status/fetch?showOnDocuments=${this.props.showOnDocuments}`;
            endpoint = '/secondary-copy-transfer-status'
        } else if (type === "edefter") {
            url = `/edefter-status/fetch?showOnDocuments=${this.props.showOnDocuments}`;
            endpoint = '/edefter-status'
        } else if (type === "sgkInvoice"){
            url = `/waitedGibOutbox/getSgkUnBillingInvoiceCount?&timeType=`;
            endpoint = '/waitedGibOutbox'
        } else if (type === "eExpenseNote") {
            url = `/eExpenseNoteStatus/fetch?showOnDocuments=${this.props.showOnDocuments}&timeType=`;
            endpoint = '/eExpenseNoteStatus';
        }
        this.setState({endpoint})
        return url + dateType;
    }

    goDetail(item ,sgkType) {
        let self = this;
        let endpoint = self.state.endpoint;
        let documentTitle = self.props.documentTitle.toLocaleUpperCase('tr-TR');
        self.props.handleDetail(item,documentTitle,
                                self.props.type,
                                endpoint,
                                sgkType);
    }

    getList() {
        //let list = this.state.documentStatusList[this.props.type];
        let list = this.state.documentStatusList;
        if (list !== undefined)
            return list;
        else
            return [];
    }

    getExplanationColor(item) {
        if (item.successFaultProcess === "S")
            return "text-success";
        else if (item.successFaultProcess === "F")
            return "text-danger";
        else
            return "text-warning";
    }

    showStatusCode(item) {
        let self = this;
        let type = this.props.type;
        let statusCode = "";
        if (["invoice", "despatch"].includes(type))
            statusCode = item.processResult;
        else
            statusCode = item.processState + "-" + item.processResult;
        return statusCode;

    }

    setDocumentStatusList(data) {
        let self = this;
        let documentStatusList = self.state.documentStatusList;
        documentStatusList = data;
        self.setState({documentStatusList});
    }

    createColumns(){
        let self = this;
        const type = self.props.type;
        const columns = getDocumentStatusColumns(type);
        let content = [];
        for (const index in columns) {
            if(columns.length-1 === index)
                content.push((<th style={{margin: 0, padding: 0, maxWidth: "70px !important"}}></th>));
            else
                content.push((<th style={{fontSize: "12px", margin: 0, padding: 0, fontWeight: "bold"}}>{columns[index]}</th>))
        }
        return (
            <thead>
            <tr>
                {content}
            </tr>
            </thead>
        )
    }

    createBody(){
        let self = this;
        if(self.props.type === "sgkInvoice")
        {
            return self.getList().map((item, index) => (
                <tr key={index}>
                    <td style={{padding: 0, margin: 0, textAlign: "left"}}>{item.title}</td>
                    <td style={{padding: 0, margin: 0}}>{item.count}</td>
                    <td style={{padding: 0, margin: 0}}>
                        <Button size="sm"
                                style={{backgroundColor: "#6e8da2", fontSize: "12px"}}
                                onClick={() => this.goDetail(item,item.type)}>Detay</Button>
                    </td>
                </tr>
            ));

        }else{
            return self.getList().map((item, index) => (
                <tr key={index}>
                    <td style={{padding: 0, margin: 0, textAlign: "left"}}>{this.showStatusCode(item)}</td>
                    <td style={{padding: 0, margin: 0, textAlign: "left"}}><p
                        className={this.getExplanationColor(item)}
                        style={{margin: 0, padding: 0}}>{item.explanation}</p></td>
                    <td style={{padding: 0, margin: 0}}>{item.count}</td>
                    <td style={{padding: 0, margin: 0}}>
                        <Button size="sm"
                                style={{backgroundColor: "#6e8da2", fontSize: "12px"}}
                                onClick={() => this.goDetail(item)}>Detay</Button>
                    </td>
                </tr>
            ));
        }
    }

    render() {

        return (
            <div className="col-sm-6">
                <h6 className="text-center" style={{
                    backgroundColor: "#6e8da2",
                    margin: 0,
                    padding: "5px",
                    borderRadius: "5px"
                }}>
                    {this.props.documentName.toLocaleUpperCase('tr-TR')}

                </h6>
                <Table striped bordered size="sm">
                    {/*<thead>
                    <tr>
                        <th style={{fontSize: "12px", margin: 0, padding: 0, fontWeight: "bold"}}>Kod</th>
                        <th style={{
                            fontSize: "12px",
                            margin: 0,
                            padding: 0,
                            fontWeight: "bold"
                        }}>{this.props.documentName} Durumu
                        </th>
                        <th style={{
                            fontSize: "12px",
                            margin: 0,
                            padding: 0,
                            fontWeight: "bold"
                        }}>{this.props.documentName} Sayısı
                        </th>
                        <th style={{margin: 0, padding: 0, maxWidth: "70px !important"}}></th>
                    </tr>
                    </thead>*/}{this.createColumns()}

                    <tbody>
                    {this.state.loading ?
                        <tr>
                            <td colSpan={3}>
                                <ReactLoading type="spinningBubbles" style={{
                                    width: "70px",
                                    height: "70px",
                                    margin: "20px auto 0 auto",
                                    fill: "#888"
                                }}/></td>
                        </tr>

                        :
                        this.createBody()

                        /*this.getList().map((item, index) => (
                            <tr key={index}>
                                <td style={{padding: 0, margin: 0, textAlign: "left"}}>{this.showStatusCode(item)}</td>
                                <td style={{padding: 0, margin: 0, textAlign: "left"}}><p
                                    className={this.getExplanationColor(item)}
                                    style={{margin: 0, padding: 0}}>{item.explanation}</p></td>
                                <td style={{padding: 0, margin: 0}}>{item.count}</td>
                                <td style={{padding: 0, margin: 0}}>
                                    <Button size="sm"
                                            style={{backgroundColor: "#6e8da2", fontSize: "12px"}}
                                            onClick={() => this.goDetail(item)}>Detay</Button>
                                </td>
                            </tr>
                        ))*/}
                    </tbody>
                </Table>
            </div>
        );
    }
}

export default GibDocumentList;